import { Accordion } from '@connected/ui/components/accordion';
import { Section } from '@connected/ui/features/layouts';

import type { ObservationLog } from '../utils/observation-log-types';

import { ObservationLogEntry } from './observation-log-entry';
import { ObservationLogHeader } from './observation-log-header';

export type ObservationLogSectionProps = {
    observationLog: ObservationLog;
};

export function ObservationLogSection({ observationLog }: ObservationLogSectionProps) {
    const logs = observationLog.Logs ?? [];

    const lastLogStatus = logs.length > 0 ? logs[logs.length - 1].NewStatus : null;
    const status = lastLogStatus === 'SolutionApproved'
        ? 'Approved'
        : lastLogStatus === 'SolutionRejected'
            ? 'Rejected'
            : undefined;

    return (
        <Section>
            <ObservationLogHeader observationLog={observationLog} status={status} />
            {
                logs.length === 0
                    ? (
                            <p className="text-text-secondary text-sm italic px-6 pb-6 mt-6">Er zijn nog geen logboek items voor deze constatering.</p>
                        )
                    : (
                            <Accordion type="single" collapsible className="p-6 gap-0">
                                {logs.map((log, index) => (
                                    <ObservationLogEntry
                                        observationLogEntry={log}
                                        index={index}
                                        isLast={index === logs.length - 1}
                                        key={log.ElectricalProjectObservationLogId}
                                    />
                                ))}
                            </Accordion>
                        )
            }
        </Section>
    );
}
